export default "__VITE_ASSET__BDH1ozWz__"